document.addEventListener("DOMContentLoaded", () => {
  const nextOrderItemCheckboxes = document.querySelectorAll('.next-order-item-checkbox__input');
  nextOrderItemCheckboxes.forEach(nextOrderItemCheckbox => nextOrderItemCheckbox.addEventListener('change', () => changeNextOrderItemCheckbox(event)));

  function changeNextOrderItemCheckbox(event) {
    let target = event.target || event.srcElement;
    const variantId = target.getAttribute("data-variant-id");
    const customerID = target.getAttribute("data-customer-id");
    const redirectUrl = target.getAttribute("data-redirect-url");

    const checkboxComponentEl = document.getElementById(`next-order-item-checkbox-${variantId}`);

    let xhr = new XMLHttpRequest();

    if(target.checked) {
      // CREATE
      let url = `/a/account/${customerID}/next_order_items/create`;
      xhr.open("POST", url);
    } else {
      // DELETE
      let url = `/a/account/${customerID}/next_order_items/destroy_by_variant`;
      xhr.open("POST", url);  
    }   

    xhr.setRequestHeader("Accept", "application/json");
    xhr.setRequestHeader("Content-Type", "application/json");

    checkboxComponentEl.classList.add('next-order-item-checkbox--loading');

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if(xhr.status === 400) {
          const responseJSON = JSON.parse(xhr.response);
          console.log(responseJSON.error);
        } else if(xhr.status === 200) {

        }

        checkboxComponentEl.classList.remove('next-order-item-checkbox--loading');

        // Need to redirect in My Cellar to refresh the list and the list of variant IDs from the metafields for the Add All to Basket button
        if(redirectUrl !== undefined && redirectUrl !== null && redirectUrl !== "") {
          location.href = redirectUrl;
        }
      }};

    let data = `{
      "shopify_variant_id": ${variantId}
    }`;

    xhr.send(data);
  }

  // Modal Remove Links
  const nextOrderItemModalRemoveLinks = document.querySelectorAll('.next-order-item-modal__remove-link');
  nextOrderItemModalRemoveLinks.forEach(nextOrderItemModalRemoveLink => nextOrderItemModalRemoveLink.addEventListener('click', () => removeNextOrderItemById(event)));

  function removeNextOrderItemById(event) {
    event.preventDefault();

    let target = event.target || event.srcElement;

    const customerID = target.getAttribute("data-customer-id");
    const nextOrderItemID = target.getAttribute("data-next-order-item-id");

    let url = `/a/account/${customerID}/next_order_items/${nextOrderItemID}/destroy`;
    let xhr = new XMLHttpRequest();
    xhr.open("DELETE", url);

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if(xhr.status === 400) {
          const responseJSON = JSON.parse(xhr.response);
          const errorsEl = document.getElementById(`next-order-item-modal-error-${nextOrderItemID}`);
          errorsEl.style.display = "block";
          console.log(responseJSON.error);
          errorsEl.innerHTML = "Could not delete next order item";
        } else if(xhr.status === 200) {
          const nextOrderItemEl = document.getElementById(`next-order-item-${nextOrderItemID}`);
          nextOrderItemEl.remove();

          const nextOrderItemModal = document.getElementById(`PopupModal-NOI-${nextOrderItemID}`);
          nextOrderItemModal.removeAttribute('open');
        }

      }};

    xhr.send();
  }

  // Add All to Basket 
  const nextOrderItemAddAllButton = document.getElementById('next-order-add-all-button');

  // nextOrderItemAddAllButton.addEventListener('click', (event) => {
  nextOrderItemAddAllButton.onclick=async(event) => {
    event.preventDefault();

    let target = event.target || event.srcElement;
    const variantIds = target.getAttribute("data-variant-ids").split(",");

    const nextOrderItemQuantityInputs = document.querySelectorAll('.next-order-item__quantity-input');

    if(nextOrderItemQuantityInputs.length > 0) {
      let formItems = [];

      for (nextOrderItemQuantityInput of nextOrderItemQuantityInputs) {
        const variantStockQty = parseInt(nextOrderItemQuantityInput.getAttribute("data-available-stock"));
        const variantShopifyId = nextOrderItemQuantityInput.getAttribute("data-variant-shopify-id");

        if(variantStockQty > 0) {
         formItems.push({'id': variantShopifyId, 'quantity': parseInt(nextOrderItemQuantityInput.value) });
        }
      }

      // console.log(formItems);

      let formData = {
            'items': formItems
          };

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        credentials: "same-origin",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });

      location.href = "/cart";
    
    }

    };

    // Next Order Item Quantity buttons

    const nextOrderItemQuantityButtons = document.querySelectorAll('.next-order-item__quantity-selector__button');

    nextOrderItemQuantityButtons.forEach(nextOrderItemQuantityButton => nextOrderItemQuantityButton.addEventListener('click', () => nextOrderItemQuantityButtonClicked(event)));

    function nextOrderItemQuantityButtonClicked(event) {
      event.preventDefault();

      let target = event.target || event.srcElement;
      let nextOrderItemId = target.getAttribute("data-next-order-item-id");
      let customerId = target.getAttribute("data-customer-id");

      const existingQuantity = parseInt(document.getElementById(`next-order-item__quantity-${nextOrderItemId}`).value);
      let newQuantity = existingQuantity;

      if(target.getAttribute("name") === "minus") {
        if(existingQuantity > 1) {
          newQuantity = existingQuantity - 1;
          updateNextOrderItemQuantity(customerId, nextOrderItemId, newQuantity);
        }
      } else if(target.getAttribute("name") === "plus") { 
        newQuantity = existingQuantity + 1;
        updateNextOrderItemQuantity(customerId, nextOrderItemId, newQuantity);
      }
    }

    // Next Order Item Input Field

    const nextOrderItemQuantityInputs = document.querySelectorAll('.next-order-item__quantity-input');

    nextOrderItemQuantityInputs.forEach(nextOrderItemQuantityInput => nextOrderItemQuantityInput.addEventListener('change', () => nextOrderItemQuantityInputChanged(event)));

    function nextOrderItemQuantityInputChanged(event) {
      let target = event.target || event.srcElement;
      const nextOrderItemId = target.getAttribute("data-next-order-item-id");
      const customerId = target.getAttribute("data-customer-id");
      const newQuantity = parseInt(target.value);

      updateNextOrderItemQuantity(customerId, nextOrderItemId, newQuantity);
    }


    // Update Next Order Item QTY
    function updateNextOrderItemQuantity(customerId, nextOrderItemId, newQuantity) {
      console.log(`updateNextOrderItemQuantity - id: ${nextOrderItemId}, qty ${newQuantity} `);

      const quantityInput = document.getElementById(`next-order-item__quantity-${nextOrderItemId}`);
      const availableStock = parseInt(quantityInput.getAttribute("data-available-stock"));
      let lowStockAdjustmentApplied = false;

      if(availableStock < newQuantity) {
        lowStockAdjustmentApplied = true;
        newQuantity = availableStock

        if(newQuantity < 0) {
          newQuantity = 1;
        }
      }

      const parentQuantityEle = document.getElementById(`next-order-item__quantity-selector-${nextOrderItemId}`);
      parentQuantityEle.classList.add("loading");

      let url = `/a/account/${customerId}/next_order_items/${nextOrderItemId}/update_quantity`;
      let xhr = new XMLHttpRequest();
      xhr.open("PATCH", url);
  
      xhr.setRequestHeader("Accept", "application/json");
      xhr.setRequestHeader("Content-Type", "application/json");
  
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          console.log(xhr.status);
          if(xhr.status === 400) {
            const responseJSON = JSON.parse(xhr.response);
            parentQuantityEle.classList.remove("loading");

          } else if(xhr.status === 200) {
            const responseJSON = JSON.parse(xhr.response);

            //Update Saved Quantity
           
            quantityInput.value = responseJSON.next_order_item.quantity;

            parentQuantityEle.classList.remove("loading");   

            if(lowStockAdjustmentApplied == true) {
              alert(`We currently only have ${availableStock} bottles available.`);
            }
            
          }
          
        }};
  
      let data = `{
        "quantity": ${newQuantity}
      }`;
  
      xhr.send(data);
    }
  

    
 

});